module.exports = __webpack_public_path__ + "static/media/30.0d39ec23.jpg";